
export default {
  DailyRecurrenceMode: {
    UseInterval: 'UseInterval',
    WeekDays: 'WeekDays',
    WeekendDays: 'WeekendDays',
  },
  ScheduleDayOfWeek: {
    Sunday: 'Sunday',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
  },
  ScheduleMonthOfYear: {
    January: 1,
    February: 2,
    March: 3,
    April: 4,
    May: 5,
    June: 6,
    July: 7,
    August: 8,
    September: 9,
    October: 10,
    November: 11,
    December: 12,
  },
  OccurrenceInMonth: {
    First: 'First',
    Second: 'Second',
    Third: 'Third',
    Fourth: 'Fourth',
    Last: 'Last',
  },
  RecurrenceEndMode: {
    noEndDate: 'NoEndDate',
    occurrences: 'Occurrences',
    endDate: 'EndDate'
  },
  RecurrenceType: {
    Daily: 'Daily',
    Weekly: 'Weekly',
    Monthly: 'Monthly',
    MontNth: 'MontNth',
    Yearly: 'Yearly',
    YearNth: 'YearNth',
  },
  Language: {
    nl: 1,
    fr: 2,
    en: 3
  },
  DurationStep: 15,
  Alarm: {
    Never: 0,
    FiveMinitues: 5,
    TenMinitues: 10,
    FifteenMinitues: 15,
    ThirtyMinutes: 30,
    OneHour: 60,
    TwoHours: 120,
    FourHours: 240,
  },
    TranslateMonthOfYear: {
        1:"january",
        2:"february",
        3:"march",
        4:"april",
        5:"may",
        6:"june",
        7:"july",
        8:"august",
        9:"september",
        10:"october",
        11:"november",
        12:"december",
    },
}